import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import { getConfigValues } from "../../Helpers/APIEndPoints/EndPoints";
import SanjeevaniTabs from "../MemberDashboard/SanjeevaniTabs";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { AppModules } from "../../Helpers/Enums/AppModules";

const BenefitSanjeevani = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [sanjeevanBeni, setSanjeevanBeni] = React.useState<string>("");
  const [sanjeevanDesc, setSanjeevanDesc] = React.useState<string>("");
  let { selectNextTab } = props;
  const { appModule } = props;

  useEffect(() => {
    callConfigData();
  }, [appModule]);
  // console.log("Current Module benifit: " + appModule);

  const callConfigData = async () => {
    showLoader();
    let configKeys = [];
    let descKey = "";
    let benefitKey = "";

    if (appModule === AppModules.SanjeevaniYojana) {
      configKeys = ["SanjivaniyojnaBenefits", "SanjeevaniYojnaDescription"];
      descKey = "SanjeevaniYojnaDescription";
      benefitKey = "SanjivaniyojnaBenefits";
    } else if (appModule === AppModules.SuvidhaYojna) {
      configKeys = ["SuvidhayojnaBenefits", "SuvidhaYojnaDescription"];
      descKey = "SuvidhaYojnaDescription";
      benefitKey = "SuvidhayojnaBenefits";
    }

    const result = await APICall(getConfigValues, { Keys: configKeys });

    if (result && result.Message === "Ok" && result.Data.length > 0) {
      result.Data.forEach((cd) => {
        if (cd.Key === descKey) {
          setSanjeevanDesc(cd.Value);
        } else if (cd.Key === benefitKey) {
          setSanjeevanBeni(formatText(cd.Value));
          // setSanjeevanBeni(cd.Value);
        }
      });
    }

    hideLoader();
  };

   // Helper function to replace '@' with '>' and new lines with <br />
  const formatText = (text) => {
    return text
      .replace(/@/g, "&#8226;")       // Replace '@' with '>'
      .replace(/\n/g, "<br />"); // Replace new lines with <br />
  };


  return (
    <div>
      {/* <SanjeevaniTabs /> */}
      <>
        <h4 className="font-weight-bold text-center mb-3">Description</h4>
        <p>{sanjeevanDesc}</p>
        <h4 className="font-weight-bold text-center mb-3 mt-3">Benefits</h4>
        <p dangerouslySetInnerHTML={{ __html: sanjeevanBeni }} 
        // style={{ marginLeft: "200px", marginRight: "200px" }} 
        // style={{ textAlign: "center" }} 
        />
        {/* <p>{sanjeevanBeni}</p> */}
        {/* <ButtonComponent
          icon={""}
          value={"Next"}
          style={{ marginLeft: "10px" }}
          id={"saveBtn"}
          onClick={() => {
            selectNextTab();
          }}
        /> */}
      </>
    </div>
  );
};

export default BenefitSanjeevani;
